<mat-card class="!m-3">
  <mat-card-header>
    <mat-card-title>BANDEJA DE ENTRADA</mat-card-title>
  </mat-card-header>
  <mat-card-content *ngIf="tabs.length > 0">
    <mat-tab-group
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      [color]="'primary'">
      <mat-tab
        class="!uppercase"
        [label]="tab.label + ' (' + tab.tasks.length + ')'"
        *ngFor="let tab of tabs">
        <div class="mat-tab-body">
          <div
            class="mat-tab-item"
            *ngFor="let item of tab.tasks; let i = index"
            [ngClass]="{
              'mat-tab-item-white': i % 2 === 0,
              'mat-tab-item-gray': i % 2 !== 0
            }">
            <div class="mat-tab-item-body">
              <div
                class="mat-tab-status"
                [class]="'prioridad_' + item.prioridad"></div>
              <div class="md-list-item-text" layout="column">
                <p>Asunto: {{ item.asunto }}</p>
                <p>Tipo Entregable: {{ item.tipo_descripcion }}</p>
                <p>Estatus de Entregable: {{ item.estatus_descripcion }}</p>
                <p>
                  Responsable: @switch (item.estatus) { @case (1) {
                  {{ item.analista_descripcion.split("|")[0] }}
                  } @case (2) {
                  {{ item.supervisor_descripcion.split("|")[0] }}
                  } @case (3) {
                  {{ item.coordinador_descripcion.split("|")[0] }}
                  } @case (4) {
                  {{ item.coordinador_descripcion.split("|")[0] }}
                  } }
                </p>
                <p>
                  Fecha y Hora de Asignación:
                  {{ item.timestamp | date : "yyyy/MM/dd HH:mm" }}
                </p>
              </div>
            </div>
            <div class="mat-tab-item-action">
              <a
                mat-button
                class="!uppercase !whitespace-nowrap button-blue-color mdc-tab__text-label-"
                target="_blank"
                [routerLink]="['/entrada', item.tema, item.entrada]">
                Ver detalle
              </a>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
